/* tslint:disable */
/* eslint-disable */
/**
 * Haltian API-spec
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Client token object
 * @export
 * @interface ClientToken
 */
export interface ClientToken {
    /**
     * Client token
     * @type {string}
     * @memberof ClientToken
     */
    token?: string;
}

export function ClientTokenFromJSON(json: any): ClientToken {
    return ClientTokenFromJSONTyped(json, false);
}

export function ClientTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientToken {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': !exists(json, 'token') ? undefined : json['token'],
    };
}

export function ClientTokenToJSON(value?: ClientToken | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}


